// What the panel may honestly say about whether the booking link reached the
// patient.
//
// It used to say one thing in all three cases: "it is in your reply box; press
// Send Response." Reopening a task clears the reply box, so the commonest
// reading of that sentence was a lie — the office was told to press a button
// that would have sent an empty message, and the link they were looking at was
// nowhere. The only cure for a panel that misreports is to make the wording a
// function of what is actually true.
//
// Three states, and the wording never overclaims: "from here" because a link
// the office pasted into Spruce by hand is not something this can see.

export interface LinkSendFacts {
  /** The time the patient was told, already formatted; null if not seen. */
  sentAtLabel: string | null;
  /** Is the link's URL sitting in the reply box right now? */
  urlInReply: boolean;
}

export function describeLinkSend({ sentAtLabel, urlInReply }: LinkSendFacts): string {
  // Having gone out is a fact about the past and settles it: what the reply box
  // holds now is a draft of something else.
  if (sentAtLabel) return `Sent to the patient at ${sentAtLabel}.`;
  if (urlInReply) return 'Not sent from here yet — it is in your reply box; press Send Response.';
  return 'Not sent from here yet, and it is not in your reply — use Add to reply, then press Send Response.';
}
